module.exports = __webpack_public_path__ + "img/24.8136b48f.jpg";